module.exports = __webpack_public_path__ + "img/11222.1b3ef562.png";